import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 20 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 10\" id=\"icon-chevron-down\"><path fill=\"currentColor\" d=\"M10 8.555L18.534 0H20L10 10 0 0h1.465z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol